<div style="width: 100%; padding: 10px; border: 1px dashed #efefef; margin-bottom: 10px;">
    <h3 align="center"><b>Crear nueva orden</b></h3>
    <form [formGroup]="addNewOrderForm">
        <br />
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Orden</mat-label>
            <input matInput formControlName="orden">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Colada</mat-label>
            <input matInput formControlName="colada">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Clave</mat-label>
            <input matInput formControlName="clave">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Modelo</mat-label>
            <select matNativeControl formControlName="modelo">
                <option *ngFor="let m of maestros" [value]="m.modelo">
                    {{m.modelo}}
                </option>
            </select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Horno</mat-label>
            <select matNativeControl formControlName="dispUUID">
                <option *ngFor="let d of disps" [value]="d.uuid">
                    {{d.nombre}}
                </option>
            </select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Bono</mat-label>
            <input matInput formControlName="bono" type="text">
        </mat-form-field>
    </form>
    <button mat-raised-button color="warn"  mat-dialog-close (click)="onNoClick()">{{'CONFIRM_MODAL.NO' | translate }}</button>
    <button mat-raised-button color="primary"  mat-dialog-close (click)="createOT()">{{'CONFIRM_MODAL.ACCEPT' | translate }}</button>
</div>